import { render, staticRenderFns } from "./ui-info.vue?vue&type=template&id=018752e1&scoped=true&"
import script from "./ui-info.vue?vue&type=script&lang=ts&"
export * from "./ui-info.vue?vue&type=script&lang=ts&"
import style0 from "./ui-info.vue?vue&type=style&index=0&id=018752e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018752e1",
  null
  
)

export default component.exports